import { render, staticRenderFns } from "./company-lists-empty.vue?vue&type=template&id=20ec23a7&scoped=true&"
import script from "./company-lists-empty.vue?vue&type=script&lang=ts&"
export * from "./company-lists-empty.vue?vue&type=script&lang=ts&"
import style0 from "./company-lists-empty.vue?vue&type=style&index=0&id=20ec23a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ec23a7",
  null
  
)

export default component.exports